export const brandStyle =
    "brand d-flex justify-content-between align-items-center text-decoration-none";
export const brandIcon = "brand-icon";
export const brandHeader = "brand-header ml-2 mb-0";
